import React from "react";
import { JhText } from "designPackages/textPackage";
import { JhButton } from "designPackages/buttonPackage";
import { Rocket } from "lucide-react";
import JobBoost from "components/JobBoost";
import { getBoostDetails } from "services/boostUtils";
import UpgradeToPremiumCta from "components/UpgradeToPremiumCta";
import styles from "./MessageBanner.module.css";
import { useTabStore } from "zustandStores/tabStore";
import { PREMIUM_JOB } from "services/constants";

interface MessageBannerProps {
  job: any;
  onJobUpgrade: (response: any, data: any) => void;
  styledMessaging: any;
  onHiringNudgeResponse?: (response: boolean) => void;
}

const MessageBanner: React.FC<MessageBannerProps> = ({
  job,
  onJobUpgrade,
  styledMessaging,
  onHiringNudgeResponse
}) => {
  if (!job?.messaging) return null;
  const { jobPlan } = job || {};
  const isPremium = jobPlan === PREMIUM_JOB;
  const { initialState } = getBoostDetails(job?.boost_details);
  const isJobBoostAllowed = initialState && isPremium;
  const { updateSingleJob } = useTabStore();

  return (
    <div
      style={{ backgroundColor: styledMessaging?.bgcolor }}
      className={`px-2.5 py-1.5 rounded-lg flex justify-between items-center mb-2.5 gap-0.5`}
    >
      <div className={styles.messageContent}>
        <JhText variant="caption1" style={{ color: styledMessaging?.h1Color }}>
          <span dangerouslySetInnerHTML={{ __html: styledMessaging?.h1 }} />
        </JhText>
        <JhText variant="caption2" style={{ color: styledMessaging?.h2Color }}>
          <span dangerouslySetInnerHTML={{ __html: styledMessaging?.h2 }} />
        </JhText>
      </div>

      {/* Show Yes/No buttons for hiring nudge */}
      {job?.show_hiring_nudge && (
        <div className="flex gap-2">
          <JhButton
            onClick={() => onHiringNudgeResponse && onHiringNudgeResponse(true)}
            size="xs"
            variant="outline"
          >
            Yes
          </JhButton>
          <JhButton
            onClick={() =>
              onHiringNudgeResponse && onHiringNudgeResponse(false)
            }
            size="xs"
            variant="outline"
          >
            No
          </JhButton>
        </div>
      )}

      {/* Show premium upgrade CTA */}
      {job?.show_premium_insight && job?.allow_action && (
        <UpgradeToPremiumCta
          hideSubTag={true}
          item={job}
          page="job-list"
          onClickHandler={onJobUpgrade}
          view="view-6"
        />
      )}

      {/* Show boost button */}
      {isJobBoostAllowed && job?.allow_action && (
        <JobBoost
          data={{ source: "JOB_LIST", jobId: job?.job_id }}
          callBack={() => {
            updateSingleJob(job?.job_id);
          }}
          boostDetails={job?.boost_details}
          renderFunction={({ onBoost }) => (
            <JhButton
              onClick={() => onBoost()}
              size="xs"
              variant="outline"
              className="flex items-center gap-1"
            >
              <div className="flex items-center gap-1">
                <Rocket size={16} color="var(--info-foreground)" />
                Boost
              </div>
            </JhButton>
          )}
        ></JobBoost>
      )}
    </div>
  );
};

export default MessageBanner;
